export const APP_NAME = 'Burnboxing'
export const APP_VERSION = '2.0.1'
export const PERSIST_STORE_NAME = 'admin'
export const REDIRECT_URL_KEY = 'redirectUrl'
export const FORMAT_DATE_YYYY_MM_DD = 'YYYY-MM-DD'
export const MONTH_DAYS = 30
